// state.js

export default {
    treeList: [],
};
